import getShopId from '@core/reducers/shop/selectors/getShopId';
import getGroceriesTabSelected from '@shopDetails/selectors/getGroceriesTabSelected';
import { SHOP_TABS, SHOP_TAB_INDEX } from '@shopDetails/constants';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import { track, logError } from '@tracking';

const EVENT_NAME = 'shop_details_tab.clicked';

const activeScreen = state => {
  const shopDetailsTabType = getGroceriesTabSelected(state);
  return shopDetailsTabType === SHOP_TAB_INDEX
    ? SHOP_TABS[0].name
    : SHOP_TABS[1].name;
};

const trackShopDetailsTabs = () => (dispatch, getState) => {
  try {
    const state = getState();
    const shopId = getShopId(state);
    const tabName =
      activeScreen(state) === 'Catálogo' ? 'catalog' : 'sections_list';
    const businessType = getShopBusinessType(state);

    const payload = {
      shopId,
      tabName,
      businessType,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackShopDetailsTabs;
